import { FC, useEffect, useMemo } from 'react';
import { getAttachmentUrl } from '@connect-x-app/hybrid-data-access';
import { AttachmentData } from '@connect-x-app/shared-domain-models';
import { COLORS } from '@connect-x-app/shared-ui';
import { normalizeAttachmentType } from '@connect-x-app/shared-utils';
import { Icon } from '@connect-x-app/web-ui';
import classNames from 'classnames';

import { PdfViewer } from '../pdfViewer/PdfViewer';

import './AttachmentPreview.scss';

type AttachmentPreviewProps = {
  attachment?: AttachmentData;
  file: string;
  isFullScreen?: boolean;
  onClose?: () => void;
};

export const AttachmentPreview: FC<AttachmentPreviewProps> = ({ attachment, file, isFullScreen, onClose }) => {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape' && onClose) {
        onClose();
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [onClose]);

  const isPdfFile = useMemo(() => {
    if (attachment) {
      return normalizeAttachmentType(attachment.type).includes('application/pdf');
    }
    return file.includes('application/pdf');
  }, [attachment, file]);

  return (
    <div
      className={classNames('chat-image-preview-container', {
        isFullScreen,
      })}
    >
      <Icon
        className="close-icon"
        colorName={isFullScreen ? COLORS.yuma.$01 : COLORS.zulu.$08}
        name="resCrossTemplateOutline"
        onClick={onClose}
        size={2.4}
      />
      {isPdfFile ? (
        <PdfViewer pdf={attachment?.data ?? file} />
      ) : (
        <img
          alt={'Preview of the upload'}
          className="image-preview"
          crossOrigin="anonymous"
          src={attachment ? getAttachmentUrl(attachment) : file}
        />
      )}
    </div>
  );
};
